var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 295,
    height: 140,
    viewBox: "0 0 295 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "HomeRetirePension-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 106,
    transform: "translate(-0.378 0.207)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -1051)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 140,
    transform: "translate(40 1051)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.001 1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1,75.779l-.733-.455-.21-.136a6.994,6.994,0,0,0,5.806-6.563,6.916,6.916,0,0,0-.605-3.185,7.009,7.009,0,0,0-4.485-3.873l.021,2.882-1.583-3.135h-.019a6.994,6.994,0,0,0-7.317,6.659v.4a8.363,8.363,0,0,1-1.38-2.039,11.853,11.853,0,0,1-.63-5.244c.105-4.078.281-8.186.517-12.281a6.989,6.989,0,0,0,6.209-6.615c.01-.214,0-.426,0-.634V41.4c-.012-.2-.033-.4-.062-.6a.632.632,0,0,0-.019-.1q-.041-.252-.1-.5c-.014-.062-.029-.122-.047-.184a5.229,5.229,0,0,0-.172-.527c-.021-.057-.045-.114-.067-.172q-.074-.191-.16-.377c-.031-.066-.06-.131-.091-.195,0-.016-.016-.033-.024-.05a7,7,0,0,0-8.217-3.545l.048,3.748L11.2,35.8a6.955,6.955,0,0,0-3.336,7.535c.01.05.026.1.038.146.021.093.045.184.071.276.033.117.069.231.109.345.029.086.057.172.09.257.048.124.1.245.155.365.033.071.06.143.095.212.088.172.185.357.288.529.036.06.078.117.116.172.076.115.15.231.233.345.05.069.1.134.157.2.076.1.154.193.236.284s.117.131.172.195.173.172.264.264c.06.057.121.115.183.172.1.091.212.172.321.264.055.043.109.088.172.129.173.122.336.238.518.345.033.021.067.038.1.057.147.086.3.172.452.245.066.033.135.06.2.091.128.057.255.112.385.162.076.029.154.055.231.081.128.045.259.084.39.121.079.022.157.043.236.062.143.034.288.062.436.088h.028q-.145,2.585-.257,5.186a7,7,0,0,0-9.711-3.033L4.815,54.28l-2.544-2.44A6.966,6.966,0,0,0,.01,56.665a6.85,6.85,0,0,0,.172,1.927,7,7,0,0,0,12.866,1.9c0,.172-.012.345-.017.526a13.853,13.853,0,0,0,.8,6.091,12.26,12.26,0,0,0,2.577,3.473q.954.972,1.968,1.88a7.017,7.017,0,0,0,2.511,2.113q1.663,1.279,3.45,2.4l.742.46c.666.412,1.349.836,2.018,1.277-.117-.012-.235-.026-.354-.031a7,7,0,0,0-6.891,4.552l4.372,3.554-4.809-1.113a7,7,0,0,0,10.032,6.3l-.324.4c-.216.267-.429.533-.638.8-2.846,3.6-3.636,7.017-2.228,9.623l1.7-.923c-1.371-2.537.69-5.784,2.042-7.494.205-.26.416-.517.626-.782,1.816-2.256,3.886-4.813,3.833-7.952C34.384,80.912,29.789,78.066,26.1,75.779Z",
    transform: "translate(0 -1.202)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.807,44.747l.376-.779c.035-.074.067-.15.1-.226a6.991,6.991,0,0,1-7.9-11.118l1.516,2.451-.345-3.493.016-.012a7,7,0,0,1,9.749,1.7c.078.109.145.222.214.334a8.34,8.34,0,0,0,.072-2.463,11.939,11.939,0,0,0-2.282-4.765c-2.277-3.385-4.629-6.758-7.022-10.091a7,7,0,0,1-8.8-2.256c-.124-.172-.235-.355-.345-.536-.026-.045-.052-.091-.076-.138-.1-.172-.19-.358-.271-.541l-.036-.091a4.5,4.5,0,0,1-.173-.476c-.021-.06-.041-.119-.059-.172-.055-.172-.1-.355-.143-.534-.014-.06-.024-.121-.036-.172-.026-.134-.048-.271-.066-.405-.01-.072-.021-.143-.028-.214V10.7A6.984,6.984,0,0,1,46.3,3.288l1.971,3.19-.345-3.447A6.951,6.951,0,0,1,54.787,7.6c.017.048.029.1.047.145.031.09.06.172.088.271s.064.233.093.345c.021.088.043.172.062.265.026.129.045.26.064.391.012.076.026.152.034.227.022.2.036.4.04.6v.212c0,.138,0,.276-.012.412a2.064,2.064,0,0,1-.026.255c-.012.122-.026.246-.045.367-.014.088-.029.172-.047.259-.024.122-.052.245-.081.365-.021.081-.041.162-.064.243-.038.131-.083.262-.129.393-.022.066-.043.133-.069.2-.074.191-.155.381-.247.565-.017.034-.038.069-.057.1-.078.152-.16.3-.25.448-.038.062-.081.124-.121.186-.078.115-.155.229-.238.345-.05.066-.1.129-.152.193-.084.105-.172.208-.266.31a2.235,2.235,0,0,1-.164.172c-.1.105-.212.207-.323.307L52.9,15.2q1.513,2.109,3,4.238a6.988,6.988,0,0,1,6.568-7.755l.773,3.521.838-3.423a6.966,6.966,0,0,1,4.5,2.863,6.842,6.842,0,0,1,.885,1.723,6.993,6.993,0,0,1-9.832,8.5c.1.147.2.291.3.436a13.78,13.78,0,0,1,2.587,5.57,12.26,12.26,0,0,1-.311,4.309q-.285,1.331-.652,2.642a7.009,7.009,0,0,1-1.006,3.126c-.479,1.313-1.018,2.606-1.621,3.867l-.378.784c-.345.7-.69,1.429-1.019,2.159.093-.072.185-.147.283-.215a7.008,7.008,0,0,1,8.258.15L64.292,53.04l3.462-3.516a6.994,6.994,0,0,1-5.088,10.685l.49.172.966.331c4.333,1.515,6.835,3.976,7.044,6.93l-1.942.138c-.2-2.876-3.686-4.512-5.745-5.231-.312-.11-.63-.217-.949-.326-2.744-.931-5.864-1.985-7.5-4.662C52.569,53.519,54.921,48.656,56.807,44.747Z",
    transform: "translate(-1.422 -0.104)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.747,31.752l.863-.064.248-.024a6.991,6.991,0,0,1,5.692-12.391l-1.369,2.535,2.858-2.042a.069.069,0,0,1,.017.009,6.987,6.987,0,0,1,3.387,9.291c-.055.121-.121.234-.182.345a8.391,8.391,0,0,0,2.173-1.167,11.84,11.84,0,0,0,3-4.345c1.8-3.661,3.553-7.381,5.25-11.114a6.984,6.984,0,0,1-2.43-8.741c.09-.195.191-.379.3-.562l.079-.134c.107-.172.217-.345.337-.5.018-.028.041-.052.06-.078.1-.136.212-.267.322-.393l.127-.141c.126-.134.256-.265.392-.389.044-.041.093-.079.138-.121.1-.09.21-.172.319-.26.057-.043.112-.088.173-.129l.044-.034a7,7,0,0,1,8.923.67l-1.784,3.3,2.827-2.013a6.942,6.942,0,0,1-.543,8.219c-.033.04-.07.074-.1.112-.062.072-.126.143-.191.21s-.173.172-.255.257-.131.126-.2.186c-.1.086-.2.172-.307.25-.06.048-.119.1-.181.145-.162.119-.329.229-.5.334-.061.036-.123.067-.184.1-.119.069-.24.136-.364.2-.078.038-.155.071-.233.105-.114.052-.226.1-.346.143-.082.033-.163.062-.248.09-.117.041-.237.078-.355.112l-.243.065c-.134.033-.268.06-.406.084-.069.014-.136.029-.2.04-.2.031-.409.055-.616.067h-.117c-.173,0-.346.01-.518,0-.072,0-.147-.009-.221-.014a3.755,3.755,0,0,1-.416-.034l-.241-.034c-.134-.021-.268-.047-.4-.076-.079-.016-.158-.033-.238-.053-.144-.036-.285-.079-.427-.124l-.029-.009q-1.075,2.363-2.18,4.712a7,7,0,0,1,10,1.817l-2.668,2.427,3.408-.975a6.96,6.96,0,0,1-.24,5.324,6.814,6.814,0,0,1-1.051,1.623,6.994,6.994,0,0,1-12.281-4.279q-.113.238-.229.476a13.893,13.893,0,0,1-3.538,5.024,12.3,12.3,0,0,1-3.895,1.88q-1.3.419-2.617.753a7.027,7.027,0,0,1-3.213.689c-1.38.241-2.769.42-4.164.526l-.862.064c-.781.057-1.583.115-2.38.195.108.045.219.088.325.138a6.994,6.994,0,0,1,3.983,7.235l-5.519,1.122,4.775,1.243a7,7,0,0,1-11.809.925c.032.172.065.345.1.508.066.345.133.67.2,1,.847,4.508-.04,7.9-2.5,9.558L116.98,54c2.393-1.611,2.07-5.444,1.671-7.583-.06-.326-.126-.655-.191-.984-.57-2.847-1.2-6.073.293-8.831C121.025,32.454,126.417,32.064,130.747,31.752Z",
    transform: "translate(-4.034 0)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.93,48.571a40.018,40.018,0,0,1,80.032.651V121.81a7.069,7.069,0,0,1-7.071,7.066H59.93c-22.1,0-40.016-18.246-40.016-40.328A39.994,39.994,0,0,1,59.93,48.571Z",
    transform: "translate(-0.687 -0.308)",
    fill: "#d7e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.93,48.213a39.939,39.939,0,0,1,70.09-25.891A39.94,39.94,0,0,0,65.795,53.728a39.976,39.976,0,0,0-30.221,66.191A39.976,39.976,0,0,1,59.93,48.213Z",
    transform: "translate(-0.687 -0.296)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.377 33.793)",
    clipPath: "url(#HomeRetirePension-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.857,38.79s.368.425-.263,1.246-.122,2.6,1.077,2.65,1.779.551,1.49,1.216-.636,2.247.668,2.007,1.717.283,1.486.685.581-.8.581-.8.727,1.091,1.619.327,1.247-7.685-.572-7.8A46.022,46.022,0,0,0,127.857,38.79Z",
    transform: "translate(-21.768 -35.114)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.426,72.882l.414,2.922h1.865l-.622-3.34Z",
    transform: "translate(-22.116 -36.292)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.813,74.086s2.487,2.3,1.865,2.5-2.9,2.713-3.316,2.922c-.371.187-4.352,1.461-3.73,0a5.467,5.467,0,0,1,2.072-2.3l.414-2.5Z",
    transform: "translate(-22.018 -36.348)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.813,74.086s2.487,2.3,1.865,2.5-2.9,2.713-3.316,2.922c-.371.187-4.352,1.461-3.73,0a5.467,5.467,0,0,1,2.072-2.3l.414-2.5Z",
    transform: "translate(-22.018 -36.348)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,70.612l.414,2.922h1.865l-.622-3.34Z",
    transform: "translate(-22.205 -36.214)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.93,62.07l2.716-9.046s-4.559-4.175-1.451-5.427,3.937,5.01,3.937,5.01L136.1,63.461h-4.144Z",
    transform: "translate(-21.927 -35.429)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.334,55.71s-5.356,6.919-4.543,7.947,2.263,7.29,2.263,7.29-.207,2.5.622,2.5,2.9-.417,2.9-1.044-1.865-8.558-1.865-8.558l5.389-7.1Z",
    transform: "translate(-21.988 -35.714)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.826,56.038l5.388-2.922s3.731,1.879,2.695,3.548-5.8,6.053-5.8,6.053,1.45,7.1,1.244,7.306a6.83,6.83,0,0,1-3.109.835c-.622-.209-3.937-8.349-3.108-8.767s3.523-4.8,3.523-4.8Z",
    transform: "translate(-22.067 -35.625)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.541,135.461a37.184,37.184,0,0,0,4.144,2.3c.414,0,6.009,1.462,3.523,2.506s-12.02-.418-11.812-1.044,0-4.383.414-4.383S123.541,135.461,123.541,135.461Z",
    transform: "translate(-21.494 -38.443)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.834,138.488a37.185,37.185,0,0,0,4.144,2.3c.414,0,6.009,1.461,3.523,2.5s-12.02-.417-11.812-1.044,0-4.382.414-4.382S127.834,138.488,127.834,138.488Z",
    transform: "translate(-21.642 -38.547)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75,92.589a29.958,29.958,0,0,0,1.658,5.427c1.036,2.3-.207,13.15-.828,14.82s-6.631,21.5-4.767,21.709a46.952,46.952,0,0,0,5.6,0l6.01-18.995-1.037-25.466Z",
    transform: "translate(-21.497 -36.899)",
    fill: "#575a88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75,92.589a29.958,29.958,0,0,0,1.658,5.427c1.036,2.3-.207,13.15-.828,14.82s-6.631,21.5-4.767,21.709a46.952,46.952,0,0,0,5.6,0l6.01-18.995-1.037-25.466Z",
    transform: "translate(-21.497 -36.899)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.085,92.774s.828,5.636,2.694,6.889,1.244,2.5,1.244,2.5l-.829,11.063s-8.081,20.038-5.6,22.543,4.767,1.461,5.8,1.252,2.9-4.592,1.865-5.844,2.072-8.767,2.9-10.019,0-2.923,1.036-3.34,3.317-3.131,3.317-5.01,2.9-21.917,1.036-23.169-13.82,2.585-13.82,2.585Z",
    transform: "translate(-21.588 -36.876)",
    fill: "#575a88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.949,62.3a4.592,4.592,0,1,0-4.558-4.592A4.576,4.576,0,0,0,120.949,62.3Z",
    transform: "translate(-21.391 -35.625)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.713,44.2a3.757,3.757,0,1,0-3.731-3.757A3.744,3.744,0,0,0,131.713,44.2Z",
    transform: "translate(-21.791 -35.058)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2,57.872s2.486,4.592,3.73,4.592-4.973,4.8-4.973,4.8-2.072-6.053-2.486-6.262S124.2,57.872,124.2,57.872Z",
    transform: "translate(-21.53 -35.789)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.954,62.151s-5.389,1.879-5.181,2.5-1.45,2.087-1.45,2.714-.415,6.262,2.072,10.854,6.424,7.932,4.559,10.019-4.767,5.636-1.658,5.636,8.081-4.592,12.641-2.922,3.523-4.592,3.523-4.592.622-4.8-.622-6.262-5.6-11.9-5.6-13.15S129.1,60.9,128.062,60.9A9.3,9.3,0,0,0,124.954,62.151Z",
    transform: "translate(-21.457 -35.893)",
    fill: "#8985a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.918,42.873a35.768,35.768,0,0,1,1.777,3.808c.089.576,2.989-3.808,2.989-3.808l-3.316-2.3Z",
    transform: "translate(-21.961 -35.192)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.547,45.415l3.523-3.757,4.144,1.879s3.866,8.558,4.108,9.184-6.18,3.548-6.8,3.548-4.973-6.471-4.973-6.471S132.511,46.667,133.547,45.415Z",
    transform: "translate(-21.967 -35.23)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.844,50.738V54.5h2.486l-.818-3.757Z",
    transform: "translate(-21.924 -35.543)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.258,53.656a1.537,1.537,0,0,0-.882.265,1.558,1.558,0,0,0-.577.724c-.161.441-.106.905.663,1.1,1.658.417,1.864,0,1.864,0s2.878-.417,2.268-1.252-2.268-.835-2.268-.835Z",
    transform: "translate(-21.92 -35.643)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.389,72.356s2.487,2.3,1.865,2.5-2.9,2.713-3.316,2.922c-.371.187-4.352,1.461-3.73,0a5.473,5.473,0,0,1,2.072-2.3l.414-2.5Z",
    transform: "translate(-22.106 -36.288)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.234,54.162c.286-.168.623-.378.63-.711a.637.637,0,0,0-.123-.338.631.631,0,0,0-.287-.215,1.821,1.821,0,0,0-.716-.1.93.93,0,0,0-.277.028c-.236.073-.372.315-.557.479a2.324,2.324,0,0,1-.99.4,6.462,6.462,0,0,0-1.658.692.776.776,0,0,0-.262.217,1.065,1.065,0,0,0-.105.54,5.458,5.458,0,0,1-.783,1.96,2.158,2.158,0,0,0-.153,2.031,6.885,6.885,0,0,1,.41.586c.262.549-.066,1.226.124,1.8a1.579,1.579,0,0,0,.4.6,3.149,3.149,0,0,0,1.305.8c.471.146,1.055.243,1.24.7a3.829,3.829,0,0,0,.175.611.959.959,0,0,0,.681.344,2.89,2.89,0,0,0,.882.064,1.094,1.094,0,0,0,.761-.41,2.276,2.276,0,0,1,.308-.458c.3-.253.756-.053,1.141-.12a.837.837,0,0,0,.654-.618,1.173,1.173,0,0,1,.133-.473c.239-.308.869-.091,1.027-.448.1-.232-.113-.478-.321-.623a9.1,9.1,0,0,1-1.021-.7,1.2,1.2,0,0,1-.434-1.1c.143-.605.927-.938.953-1.56a1.116,1.116,0,0,0-.523-.88,8,8,0,0,1-.868-.612c-.185-.181-.326-.409-.528-.571a2.464,2.464,0,0,0-1.33-.378c-.249-.026-1.245-.142-1.2-.525C117.948,54.861,118.981,54.312,119.234,54.162Z",
    transform: "translate(-21.3 -35.614)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.464,45.333s-2.279.835-2.279,1.879-1.037,4.383,0,4.383a12.6,12.6,0,0,0,3.108-.8Z",
    transform: "translate(-21.885 -35.356)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.862,60.31s6.009-2.087,6.217-2.087,3.108-1.67,2.9-2.3l-.828-5.218s-3.316-6.888-1.036-6.888,3.523,5.427,3.523,5.427,4.973,9.393,2.279,11.48-13.884,5.845-14.506,5.218S132.862,60.31,132.862,60.31Z",
    transform: "translate(-21.905 -35.304)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.831,46.764l1.4,1.358-1.813,1.773s-2.487-1.044-2.28-.417,1.45,2.5,2.28,2.5,5.142-2.713,5.162-3.548-2.675-3.757-3.3-3.966S138.831,46.764,138.831,46.764Z",
    transform: "translate(-22.071 -35.326)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.2,45.246s3.044,2.707,3.459,2.707,1.168-4.068,1.168-4.068-2.457-1.612-3.367-1.173S136.2,45.246,136.2,45.246Z",
    transform: "translate(-22.074 -35.263)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.191,63.388s0-2.922,6.217-2.922H134.1l-1.243,6.888-4.145,1.252Z",
    transform: "translate(-21.694 -35.878)",
    fill: "#8985a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.855,38.862a15.982,15.982,0,0,1-1.823-.113A5.115,5.115,0,0,0,135.3,36.26a6.548,6.548,0,0,0-1.743-.964c-1.381-.591-3.68-.222-3.814.45-2.717,1.308-2.03,3.6-2.03,3.6.422.9,1.369.5,2.172.093a1.593,1.593,0,0,0,1.384,1.231c1.328.05,1.971.61,1.651,1.347s-.7,2.489.741,2.223,1.9.313,1.645.758.645-.886.645-.886.805,1.208,1.793.363a.755.755,0,0,0,.207-.355,1.476,1.476,0,0,0,1.03.182c1.184-.534.448-1.786.448-1.786s1.581-.244,1.072-.2-.831-.624.03-1.823S139.654,38.889,138.855,38.862Z",
    transform: "translate(-21.779 -35)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.911,38.02l-.59-.2-.589,1.782.59.2Z",
    transform: "translate(-21.851 -35.097)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,54.556s-.247.831,1.154,1.578,1.814,3.571.165,4.4-2.144,1.91-1.319,2.658,2.309,2.741.33,3.239-2.226,1.495-1.649,1.91-1.319-.747-1.319-.747-.33,1.993-2.061,1.495-6.6-9.966-4.122-11.295A70.969,70.969,0,0,1,57.9,54.556Z",
    transform: "translate(-19.046 -35.674)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.484,127.478l.536,5.039-2.323,1.44-2.144-.359,1.072-6.119Z",
    transform: "translate(-19.017 -38.189)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3,64.485a5.04,5.04,0,1,0-5-5.039A5.021,5.021,0,0,0,53.3,64.485Z",
    transform: "translate(-19.043 -35.669)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.045,62.131s.447,7.649.983,7.649-6.254-.36-6.254-.36,2.859-5.039,1.429-6.659S55.045,62.131,55.045,62.131Z",
    transform: "translate(-19.094 -35.925)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.553,103.991l2.323,9-1.787,15.3,4.11-.36,1.608-23.936Z",
    transform: "translate(-19.017 -37.379)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.553,103.991l2.323,9-1.787,15.3,4.11-.36,1.608-23.936Z",
    transform: "translate(-19.017 -37.379)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.087,131.748s.179-1.079,1.965,0,9.291,4.5,5.36,5.22-11.972-.9-11.972-1.44-.179-3.96.536-3.6S50.015,134.628,51.087,131.748Z",
    transform: "translate(-18.978 -38.32)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.639,130.4s-2.859,4.5-3.038,5.759-2.859-2.879-2.859-2.879l2.5-4.68Z",
    transform: "translate(-18.851 -38.227)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.153,104.723l-3.216,10.8s-5.718,15.3-6.075,15.119-4.646-1.26-4.824-1.8,5.36-15.119,5.36-15.119l.715-9.359Z",
    transform: "translate(-18.896 -37.392)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.108,132.7a2.335,2.335,0,0,1,1.391.345,2.361,2.361,0,0,1,.932,1.095,3.657,3.657,0,0,0,1.787,1.98c.179.18-.536,3.96,0,4.32s1.072,4.139-.715,4.139-4.646-1.979-4.467-2.339a8.091,8.091,0,0,0-.357-3.96c-.536-1.08-1.429-2.88,0-3.96S42.108,132.7,42.108,132.7Z",
    transform: "translate(-18.753 -38.369)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.952,87.264l.357,3.24a15.747,15.747,0,0,1,3.574,5.939c.893,3.239,8.219,8.639,6.075,9.359s-4.646,1.08-10.9,0-16.081,1.26-16.081-4.679c0,0-1.251-1.62-2.144.719a47.3,47.3,0,0,1-2.144,4.68s-2.144-3.78-1.429-5.4,0-1.441.893-3.24,5.36-8.459,7.147-8.819,5.182-5.039,5-5.579S58.952,87.264,58.952,87.264Z",
    transform: "translate(-18.623 -36.67)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.632,66.523s7.326,1.62,7.683,2.7a10.931,10.931,0,0,0,1.918,2.591,10.145,10.145,0,0,1,2.522,5.154c.186,1.148-.6,2.181-.955,3.5-1.072,3.96-1.876,2.97-.8,5.849s-5.36,3.959-7.862,2.7-5.271-8.729-5.271-9.629S44.45,68.322,46.416,67.6,49.632,66.523,49.632,66.523Z",
    transform: "translate(-18.951 -36.087)",
    fill: "#575a88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.183,75.47l2.144,9.539,7.058,3.15s5.36-1.26,5.539.72c.117,1.292-6.075,1.8-6.075,1.8L58.575,86.629,56.252,77.81Z",
    transform: "translate(-19.317 -36.396)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.649,71.742s4.467,2.7,3.395,4.139-3.752,3.78-4.467,3.78-1.251-4.32-1.251-5.579S57.649,71.742,57.649,71.742Z",
    transform: "translate(-19.285 -36.267)",
    fill: "#575a88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.821,52.848s-.274.92,1.279,1.748,2.009,3.956.183,4.876-2.375,2.116-1.461,2.944,2.557,3.036.365,3.588S50.721,67.66,51.36,68.12s-1.461-.828-1.461-.828-.365,2.208-2.283,1.656-3.832-10.586-1.694-13.171C47.909,53.374,52.821,52.848,52.821,52.848Z",
    transform: "translate(-18.928 -35.615)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.243,51.845c0-1.348-4-.379-5.72,1.5-1.189,1.3-2.994,3.264-1.481,4.646s-2.593,3.194-3.694,3.743-3.275,2.229-1.312,3.356,1.932,2.264,1.193,2.534,1.629-.4,1.629-.4-.239,2.226,1.756,2.215,7.718-11.053,6.351-14.123C50.692,52.464,53.243,51.845,53.243,51.845Z",
    transform: "translate(-18.765 -35.559)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.657,51.56c5.354-.325,5.891,3.734,5.891,3.734-.037,2.349-3.74,1.2-4.769,1.555-1.241-.9-3.633-2.6-5.344-3.815A8.054,8.054,0,0,1,52.657,51.56Z",
    transform: "translate(-19.048 -35.57)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9,100.3H94.189v40.237H95.9Z",
    transform: "translate(-20.625 -37.252)",
    fill: "#381e1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.189,100.252s2.91-3.679,5.307,1.092c0,0-1.141,2.127-1.484,1.092s-1.163-2.581-2.122-1.664",
    transform: "translate(-20.625 -37.203)",
    fill: "#381e1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.835,93.021s4.306,4.27,2.186,7.876a.849.849,0,0,1-.263.278.844.844,0,0,1-1.061-.107c-.731-.728-1.887-2.537-3.307-7.013Z",
    transform: "translate(-20.529 -37.001)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.674,69.729s4.451,1.38,3.6,6.783a41.222,41.222,0,0,0-.514,9.2l1.141,6.9-2.054,2.817S89.3,91.86,88.106,88.238,87.022,70.3,90.674,69.729Z",
    transform: "translate(-20.392 -36.198)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.616,69.67s4.451,1.38,3.6,6.783a41.223,41.223,0,0,0-.514,9.2l1.141,6.9-2.054,2.817s-3.538-3.564-4.737-7.185S86.963,70.244,90.616,69.67Z",
    transform: "translate(-20.39 -36.195)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3,133.394l-.73,5.5a6.8,6.8,0,0,0,2.435.6c.561-.175,1.545.535,1.545.535s4.186,1.332,5.008.135S92.515,138.6,91,137.7s-2.152-4.384-2.152-4.384Z",
    transform: "translate(-20.294 -38.39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.233,93.156V113.5l-3.881,19.429H85.244l.628-18.624s-4.28-15.06-2.4-20.694Z",
    transform: "translate(-20.239 -37.005)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.271,95.815s5.983.853,6.408,5.023a.857.857,0,0,1-.256.7.845.845,0,0,1-.328.2.832.832,0,0,1-.38.032c-1.018-.148-3.015-.91-6.8-3.657Z",
    transform: "translate(-20.443 -37.097)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.867,68.627a7.516,7.516,0,0,0-.571,4.541s-5.735-.489-5.564-3.822A4.974,4.974,0,0,0,88.185,66.1Z",
    transform: "translate(-20.299 -36.072)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.163,134.644l-.73,5.5a6.8,6.8,0,0,0,2.435.6c.561-.175,1.545.536,1.545.536s4.186,1.331,5.008.134-1.042-1.562-2.555-2.465-2.152-4.384-2.152-4.384Z",
    transform: "translate(-20.151 -38.433)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.77,94.793v20.348L84.89,134.57H80.781l.628-18.624s-4.28-15.06-2.4-20.693Z",
    transform: "translate(-20.085 -37.062)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.593,94.793v20.348L84.712,134.57H80.6l.628-18.624s-4.28-15.06-2.4-20.693Z",
    transform: "translate(-20.079 -37.062)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.558,69.775s-3.6-2.357-5.992,4.656-1.427,19.946-1.427,19.946,10.215,3.334,13.867-1.322V86.1s1.94-7.933-.8-14.83C92.208,71.27,89.811,72.247,86.558,69.775Z",
    transform: "translate(-20.1 -36.186)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.441,69.954s-3.6-2.357-5.992,4.656-1.427,19.946-1.427,19.946S89.237,97.89,92.89,93.234V86.278s1.94-7.932-.8-14.83C92.091,71.448,89.694,72.425,86.441,69.954Z",
    transform: "translate(-20.096 -36.192)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.441,69.775s-3.6-2.357-5.992,4.656-1.427,19.946-1.427,19.946,10.215,3.334,13.867-1.322V86.1s1.94-7.933-.8-14.83C92.091,71.27,89.694,72.247,86.441,69.775Z",
    transform: "translate(-20.096 -36.186)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.813,73.42s4.451,1.38,3.6,6.783a41.228,41.228,0,0,0-.514,9.2L91.6,95.206l-2.054,2.817s-8.1-2.472-9.3-6.093S79.161,74,82.813,73.42Z",
    transform: "translate(-20.121 -36.325)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.518,73.6s4.451,1.38,3.6,6.783a41.227,41.227,0,0,0-.514,9.2l5.707,5.806L89.252,98.2s-8.1-2.472-9.3-6.093S78.866,74.174,82.518,73.6Z",
    transform: "translate(-20.111 -36.331)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.637,73.42s4.451,1.38,3.6,6.783a41.223,41.223,0,0,0-.514,9.2l5.707,5.806-2.054,2.817s-8.1-2.472-9.3-6.093S78.985,74,82.637,73.42Z",
    transform: "translate(-20.115 -36.325)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.174,66.306l2.682,2.529a2.689,2.689,0,0,0-.119.245,4.026,4.026,0,0,1-3.875-.935A4.259,4.259,0,0,0,88.174,66.306Z",
    transform: "translate(-20.373 -36.08)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.763,66.569a4.656,4.656,0,1,0-4.623-4.656A4.639,4.639,0,0,0,88.763,66.569Z",
    transform: "translate(-20.279 -35.767)",
    fill: "#fffefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.562,68.8a4.656,4.656,0,1,0-4.622-4.656A4.639,4.639,0,0,0,89.562,68.8Z",
    transform: "translate(-20.306 -35.844)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.954,62.079s-1.731,4.565,1.931,5.961a2.181,2.181,0,0,0,1.155-1.607,2.192,2.192,0,0,0-.615-1.885Z",
    transform: "translate(-20.293 -35.934)",
    fill: "#fffefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.288,60.936s1.6.39-1.2,1.367a3.547,3.547,0,0,0-2.1,1.9A2.179,2.179,0,0,1,88.7,65.364a2.16,2.16,0,0,1-1.721-.157l-.885-.49L84.555,61.1l1.826-2.127,3.139-.4Z",
    transform: "translate(-20.293 -35.813)",
    fill: "#fffefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.441,66.665c.252,0,.457-.36.457-.8s-.2-.8-.457-.8-.456.36-.456.8S88.189,66.665,88.441,66.665Z",
    transform: "translate(-20.411 -36.036)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.83,69.789S89.94,74.7,91.709,74.7s-1.241-4.608-1.241-4.608L90.4,71.369Z",
    transform: "translate(-20.372 -36.2)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.59,134.4s2.216.742,3.448,0Z",
    transform: "translate(-18.156 -38.428)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.836,134.4s2.216.742,3.448,0Z",
    transform: "translate(-23.337 -38.428)",
    opacity: 0.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.c9e6bb0cf0a08e9888b59b05c882cd36.svg";
export { ForwardRef as ReactComponent };